import React, { useState } from "react";
import "./MobileNavigation.scss";
import MobileMenu from "../MobileMenu/MobileMenu";
import { isMobile } from 'react-device-detect';

function MobileNavigation() {
  const [menuList] = useState([
    { icon: "/icon/icn_menu.png", title: "Menu" },
    { icon: "/icon/icn_pocker_chip.png", title: "Casino" },
    { icon: "/icon/icn_leaderboard.png", title: "Leaderboards" },
    { icon: "/icon/icn_crystal.png", title: "Crystals" },
    { icon: "/icon/icn_chat.png", title: "Support" },
  ]);

  const [activeIndex, setActiveIndex] = useState(null);
  if (!isMobile) return null;
  return (
    <nav
      className={`mobile-navigation ${
        activeIndex !== null ? "open" : "closed"
      }`}
    >
      {menuList.map((item, index) => (
        <div
          key={index}
          className={`item ${activeIndex === index ? "open" : ""}`}
          onClick={() => setActiveIndex(activeIndex === index ? null : index)}
        >
          <img src={item.icon} alt={item.title} className='icon' />
          <span className='title'>{item.title}</span>
        </div>
      ))}
      <div className={`backdrop ${activeIndex !== null ? "open" : ""}`}>
        <MobileMenu />
      </div>
    </nav>
  );
}

export default MobileNavigation;
